module.exports = __webpack_public_path__ + "static/media/family_doctor.20eb0195.jpg";